export enum MonitorTypeEnum {
  Unknown = 0,
  Other = 1,
  Building = 10,
  Solar = 11,
  EV = 12,
  Carbon = 13,
  Battery = 14,
}
